import { render, staticRenderFns } from "./OpenIDCallback.vue?vue&type=template&id=663474dd&"
import script from "./OpenIDCallback.vue?vue&type=script&lang=js&"
export * from "./OpenIDCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VLayout,VMain,VProgressCircular})
